import type { WorldCupTab } from '../types/worldcup.types';

/**
 * Route building moved to src/competitions/helpers/competitionRoutes.helper
 * (specs/competitions-hub-client Slice 3) so one implementation serves the World
 * Cup and every other competition. Only this tab-name constant remains here.
 */

/** WorldCupTab value used as a query param when routing from a group context. */
export const WORLD_CUP_GROUPS_TAB: WorldCupTab = 'groups';
